document.addEventListener('DOMContentLoaded', function () {
  function observeChanges() {
    const targetElement = document.querySelector('.totals .totals__total-value');
    const updateElement = document.querySelector('.custom-subtotal .totals__total-value');

    if (!targetElement || !updateElement) {
      console.error('Target or update element not found. Retrying...');
      setTimeout(observeChanges, 500); // Retry after a short delay
      return;
    }

    // Create a MutationObserver instance
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'childList' || mutation.type === 'characterData') {
          updateElement.textContent = targetElement.textContent;
          console.log('Updated value:', targetElement.textContent);
        }
      });
    });

    // Observe changes to the target element's text content.
    observer.observe(targetElement, { childList: true, subtree: true, characterData: true });
    console.log('Observer is now watching for changes...');
  }

  observeChanges();
});
